<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Purchase Requsitions</h4>
                <p class="text-subtitle-1">List of purchase requsitions</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn color="primary" block @click="handleNew" v-if="hasPermission(perm.purchase_requisition.create)">
                    <v-icon left>mdi-plus</v-icon>
                    new requisition
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            block
                            depressed
                            v-on="on"
                            >
                            <v-icon left>mdi-magnify</v-icon>
                            search
                        </v-btn>
                    </template>
                    <v-card 
                        flat
                        >
                        <v-card-title>Search</v-card-title>
                        <v-card-text>
                            <PurchaseRequisitionListSearch ref="form"/>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn  color="primary" block @click="$refs.form.submit()">Submit</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <PurchaseRequisitionList/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PurchaseRequisitionList from "./../../components/purchase/PurchaseRequisitionList";
import PurchaseRequisitionListSearch from './../../components/purchase/PurchaseRequisitionListSearch';
import { mapActions, mapGetters } from 'vuex';
import permissions from '../../data/permissions';


export default {
    name: "PruchaseRequisitionListView",
    components: {
        PurchaseRequisitionList,
        PurchaseRequisitionListSearch
    },
    data() {
        return {
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            refresh: "purchase/requisition/search"
        }),
        handleNew() {
            this.$router.push({name: "PurchaseRequisitionCreate"})
        },
        handleRefresh() {
            this.refresh();
        }
    }
}
</script>

<style>

</style>